import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import classes from './InstituteDetailsBannerBlock.module.scss';

const InstituteDetailsBannerBlock = ({ pageData }) => {
    if (!pageData?.banner_block?.visible) return null;

    if (pageData?.banner_block?.images?.length === 0) return null;

    return (
        <div className={classes.InstituteDetailsBannerBlock}>
            {
                pageData?.banner_block?.images?.length === 1 ?
                    (<img src={pageData.banner_block.images[0]} 
                        className={`${classes.BannerImage} mx-auto`} 
                        alt={pageData?.institute_config?.institute_label || ''} 
                    />)
                    : (<Swiper
                        modules={[Autoplay, Pagination]}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        loop={true}
                        className={classes.BannerSwiper}
                    >
                        {
                            pageData.banner_block.images.map((img, index) => (
                                <SwiperSlide key={`banner-image-${index}`}>
                                    <img src={img} 
                                        className={classes.BannerImage} 
                                        alt={pageData?.institute_config?.institute_label || ''} 
                                    />     
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>)
            }
        </div>
    )
}

export default InstituteDetailsBannerBlock;
